import { createAxiosInterceptors } from "plantae/axios";
import authPlugin from "@daangn/plantae-plugin-auth";
import axios from 'axios';
import { isKarrotBridgeAvailable } from "../../lib/karrot_bridge_utils";

function awaitPromisePlugin(promise) {
  return {
    name: "plugin-await-promise",
    hooks: {
      beforeRequest: async (req) => {
        await promise;
        return req;
      },
    },
  };
}

export default function instance(baseURL = '') {
  const instance = axios.create({
    baseURL: baseURL || window.location.origin
  })

  instance.defaults.headers.common['Accept'] = 'application/json';

  const csrfToken = document.querySelector("meta[name=csrf-token]").content;
  instance.defaults.headers.common['X-CSRF-Token'] = csrfToken;

  const karrotBridge = window.karrotBridge;

  if (isKarrotBridgeAvailable(karrotBridge)) {
    const authCheckPromise = Promise.resolve()
      .then(() => karrotBridge.getUserInfo({}))
      .then((res) => {
        const authenticated = Boolean(res?.info?.user?.karrotUserId);
        if (authenticated) {
          const authPluginInstance = authPlugin({
            bridge: karrotBridge,
            options: {
              fallbackLegacyAuthToken: true,
            }
          });

          const {request, response} = createAxiosInterceptors({
            client: instance,
            plugins: [authPluginInstance]
          });

          instance.interceptors.request.use(request.onFulfilled, request.onRejected);
          instance.interceptors.response.use(response.onFulfilled, response.onRejected);
        }
      })
      .catch(() => {
        // If the bridge is present but fails, skip auth plugin safely.
      })

    const {request, response} = createAxiosInterceptors({
      client: instance,
      plugins: [awaitPromisePlugin(authCheckPromise)]
    });

    instance.defaults.transformResponse = [(data) => {
      if (!data || data === '') {
        return {};
      }

      return data;
    }];

    instance.interceptors.request.use(request.onFulfilled, request.onRejected);
    instance.interceptors.response.use(response.onFulfilled, response.onRejected);
  }

  return instance
}
